import React, { Component } from "react";
import { formatNumber, generateRandomString } from "../../services/util";
import { FlutterWaveButton, closePaymentModal } from "flutterwave-react-v3";
import { getFLWPublicKey } from "../../services/authService";

class Flutterwave extends Component {
  state = {
    public_key: getFLWPublicKey(),
    currency: "NGN",
    payment_options: "card,ussd",
    className: "payment-button",
    callback: async (response) => {
      this.props.verifyPayment();
      const timer = setTimeout(() => {
        this.props.callBackFromParent();
        closePaymentModal();
      }, 5000);
      return () => clearTimeout(timer);
    },
    onClose: () => {},
  };

  componentDidMount() {
    const text = <span>Pay NGN {formatNumber(this.props.amount)} With Flutterwave </span>;
    const tx_ref = `smartciti-${this.props.invoice._id}-${generateRandomString(5)}`;
    const amount = this.props.amount;
    const customer = {
      email: this.props.customer.email,
      phone_number: this.props.customer.phone,
      name: this.props.customer.fullname,
    };

    this.setState({ text, tx_ref, amount, customer });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      text: (
        <span>
          Pay &#8358;{formatNumber(nextProps.amount)} + &#8358;{formatNumber(this.calculateFees(nextProps.amount))} Fee
          With Flutterwave{" "}
        </span>
      ),
      amount: nextProps.amount + 50,
    });
  }

  // calculateFinalAmount = (amount) => {
  //   const fee = 0.014 * amount;
  //   return parseInt(amount + fee);
  // };

  calculateFees = (amount) => {
    const fee = 0.014 * (amount + 50) + 50;
    return fee;
  };

  render() {
    return <FlutterWaveButton {...this.state} />;
  }
}

export default Flutterwave;
